import axios from "axios";

let axiosInstance = axios.create({
  baseURL: window?.location?.origin,
  timeout: 20000,
});

function configAxios() {
  axiosInstance = axios.create({
    baseURL: window?.location?.origin,
    // baseURL: window?.location?.origin,SSSSS
    timeout: 20000,
  });
}

function getHeaders(token) {
  return {
    Authorization: token && `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
    // 'subscription-key': getSubscriptionKey(),
    // 'x-correlation-id': getLocalStorage(CORRELATION_ID)
  };
}

export function post(url, userData, token) {
  configAxios();
  return axiosInstance({
    method: "POST",
    url,
    data: userData,
    headers: getHeaders(token),
  });
}

export function postMultiPartFormData(url, userData, token) {
  configAxios();
  return axiosInstance({
    method: "POST",
    url,
    data: userData,
    headers: { ...getHeaders(token), "Content-Type": "multipart/form-data" },
  });
}

export function putMultiPartFormData(url, userData) {
  configAxios();
  return axiosInstance({
    method: "PUT",
    url,
    data: userData,
    headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
  });
}

// delete is a reserved name so don't use that
export function del(url, token) {
  configAxios();
  return axiosInstance({
    method: "DELETE",
    url,
    headers: getHeaders(token),
  });
}

export async function get(url, token) {
  configAxios();
  const { data } = await axiosInstance({
    method: "GET",
    url,
    headers: getHeaders(token),
  });
  return data;
}

export function put(url, data, token) {
  configAxios();
  return axiosInstance({
    method: "PUT",
    url,
    data: data,
    headers: getHeaders(token),
  });
}

export async function getPdf(id) {
  configAxios();
  const { data } = await axiosInstance({
    method: "GET",
    url: "/api/site-check/pdf-report/" + id,
    headers: getHeaders(),
    responseType: "blob",
  });
  return data;
}
